/* src/app/cron-editor-module/cron-editor.component.css */
.cron-editor-main {
  @include mat-elevation(1);
}
.cron-editor-main .cron-editor-container {
}
.cron-editor-tab-content {
  margin-top: 24px;
  border-radius: 8px;
}
.cron-editor-main .cron-editor-container .cron-editor-radio {
  width: 20px;
  display: inline-block;
}
.cron-editor-main .cron-editor-container .cron-editor-select,
.cron-editor-main .cron-editor-container .cron-editor-input,
.cron-editor-main .cron-editor-container .cron-editor-checkbox {
  display: inline-block;
}
.cron-editor-main .cron-editor-container .well-time-wrapper {
  padding-left: 20px;
}
.cron-editor-main .cron-editor-container .inline-block {
  display: inline-block;
}
.cron-editor-main .cron-editor-container .minutes,
.cron-editor-main .cron-editor-container .hours,
.cron-editor-main .cron-editor-container .days,
.cron-editor-main .cron-editor-container .seconds {
}
.cron-editor-main .cron-editor-container .months {
}
.cron-editor-main .cron-editor-container .month-days {
}
.cron-editor-main .cron-editor-container .months-small {
}
.cron-editor-main .cron-editor-container .day-order-in-month {
}
.cron-editor-main .cron-editor-container .week-days {
}
.cron-editor-main .cron-editor-container .advanced-cron-editor-input {
}
.cron-editor-main .cron-editor-container .hour-types {
  width: 70px;
}
.nav-tabs li a {
  cursor: pointer;
}
.cron-editor-radio-group {
  display: flex;
  flex-direction: column;
  margin: 15px 0;
}
.cron-editor-radio-button {
  margin: 5px;
}
.checkbox-margin {
  margin: 0 10px;
}
/*# sourceMappingURL=cron-editor.component.css.map */
